'use strict';

import React, { Component, Fragment } from 'react'

import _ from 'lodash'

import { FaRegCopy } from 'react-icons/fa6'

import { safeNumeral } from '@root/utility'

import getFormStatus from '@/Form/Functions/getFormStatus'

import { handleChange } from '@/Form/Functions/eventsHandling'

import FormElement from '@/Form/toolkit/FormElement'

import OrderCreditNotes from '@/Billing/OrderCreditNotes'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Logo   from '@Pure/Logo'

import bemit from '@function/bemit'

import { isTrue } from '@root/utility'

const { app, qwest, numeral, moment } = window;

moment.locale('fr');

numeral.locale('en');

class OrderInfos extends Component
{
	state =
	{
		selected_products: { },
		selected_tickets: { },
		all_selected: false
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'createdShipping',
			cb: component.handleShippingCreation
		});

		app.push(
		{
			event: 'providerOrdersMassAction',
			cb: component.handleProviderOrderMassAction
		});

		app.push(
		{
			event: 'changedOrderComment',
			cb: component.handleCommentChanged
		});

		component.setState(
		{
			open: props.open_by_default === true,
			loading: false,

			form_data:
			{
				[props.data.id + '-processed_by']: Boolean(props.data.processed_by)
			},

			status_messages: { }
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'createdShipping',
			cb: component.handleShippingCreation
		});

		app.delete(
		{
			event: 'providerOrdersMassAction',
			cb: component.handleProviderOrderMassAction
		});

		app.delete(
		{
			event: 'changedOrderComment',
			cb: component.handleCommentChanged
		});
	}

	handleCommentChanged = ({ id, comment }) =>
	{
		const component = this, props = this.props, state = this.state;

		if (id !== props.data.id) return;

		component.setState({ admin_comment: comment });
	}

	handleProcessedByChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		handleChange.bind(component)(e, data);

		if (!e) return; // Mounted

		component.setState({ loading: true });

		qwest.post('/order/set-processed-by',
		{
			order_id: props.data.id,
			value: data.value
		})
		.then(function (xhr, response)
		{
			component.setState({ loading: false });
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState({ loading: false });
		});
	}

	handleProviderOrderMassAction = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			selected_products: { },
			selected_tickets: { },
			all_selected: false
		});
	}

	handleShippingCreation = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			selected_products: { },
			selected_tickets: { },
			all_selected: false
		});
	}

	handleCanceledProduct = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		let all_selected = state.all_selected;

		if (data.ticket_id)
		{
			if (state.selected_tickets[data.ticket_id])
			{
				state.selected_tickets[data.ticket_id] = false;

				state.all_selected = false;
			}
		}
		else
		{
			let pattern = data.order_id + '--' + data.product_id+ '--' + data.ref;

			Object.keys(state.selected_products).forEach(function (key)
			{
				if (key === pattern)
				{
					state.selected_products[key] = false;

					state.all_selected = false;
				}
			});

			let product = props.data.products.find(data => data.price.ref === data.ref);

			if (product)
			{
				Object.keys(product.tickets).forEach(function (ticket_id)
				{
					if (state.selected_tickets[ticket_id])
					{
						state.selected_tickets[ticket_id] = false;

						state.all_selected = false;
					}
				});
			}

			state.selected_tickets
		}

		component.setState(
		{
			selected_tickets: state.selected_tickets,
			selected_products: state.selected_products,
			all_selected: state.all_selected
		});
	}

	toggle = () =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			open: !component.state.open
		});
	}

	selectItem = (e, type, data) =>
	{
		const component = this, props = this.props, state = this.state;

		let id, order_id = props.data.id;

		if (type === 'product')
		{
			id = order_id + '--' + data.id + '--' + data.price.ref;

			if (state.selected_products[id])
			{
				state.selected_products[id] = false;

				Object.keys(data.tickets).forEach(function (ticket_id)
				{
					state.selected_tickets[ticket_id] = false;
				});
			}
			else
			{
				state.selected_products[id] = true;

				Object.keys(data.tickets).forEach(function (ticket_id)
				{
					state.selected_tickets[ticket_id] = true;
				});
			}
		}
		else if (type === 'ticket')
		{
			if (state.selected_tickets[data])
			{
				state.selected_tickets[data] = false;
			}
			else
			{
				state.selected_tickets[data] = true;
			}
		}

		let all_selected = true;

		let not_selected = props.data.products.find(function (product)
		{
			return Object.keys(product.tickets).find(function (ticket_id)
			{
				return state.selected_tickets[ticket_id] !== true;
			});
		});

		component.setState(
		{
			selected_products: state.selected_products,
			selected_tickets: state.selected_tickets,
			all_selected: typeof not_selected === 'undefined'
		});

		if (props.onSelection instanceof Function)
		{
			props.onSelection(
			{
				order: props.data,
				selected: state.selected_tickets
			});
		}
	}

	selectAllItems = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const order_id = props.data.id;

		props.data.products
		.filter(function (product)
		{
			let shipping = (props.shippings || [])
			.find(function (shipping)
			{
				return shipping.products.find(data => data.price_ref === product.price.ref);
			});

			return typeof shipping === 'undefined';
		})
		.forEach(function (product)
		{
			state.selected_products[order_id + '--' + product.id + '--' +
				product.price.ref] = !state.all_selected;

			Object.keys(product.tickets)
			.filter(function (ticket_id)
			{
				let shipping = (props.shippings || [])
				.find(function (shipping)
				{
					return shipping.items.find(data => data.id === ticket_id);
				});

				if (product.tickets[ticket_id].status === 'canceled' ||
					typeof shipping !== 'undefined')
				{
					return false;
				}

				return true;
			})
			.forEach(function (ticket_id)
			{
				state.selected_tickets[ticket_id] = !state.all_selected;
			});
		});

		component.setState(
		{
			all_selected: !state.all_selected,
			selected_products: state.selected_products
		});

		if (props.onSelection instanceof Function)
		{
			props.onSelection(
			{
				order: props.data,
				selected: state.selected_tickets
			});
		}
	}

	openCommentModal = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		const current_comment = state.hasOwnProperty('admin_comment')
		? state.admin_comment
		: props.data.admin_comment;

		app.emit('open__OrderCommentModal',
		{
			order:
			{
				...(props.data || { }),

				admin_comment: current_comment
			}
		});
	}

	copyShippingNumber = (str) =>
	{
		let copied = str;

		if (typeof copied === 'string' && copied.startsWith('\n'))
		{
			copied = copied.replace('\n', '');
		}

		(async function ()
		{
			try
			{
				await navigator.clipboard.writeText(copied);
			}
			catch (error)
			{
				console.error(error);
			}
		})();
	}

	render ()
	{
		const component = this, props = this.props, state = component.state;

		const order_id = props.data.id, payment = props.data.payment;

		let products = props.data.products.map(function (product)
		{
			let thumbnail = (product.images ? (product.images[0] || { }) : { }).url;

			if (!thumbnail && product.artist)
			{
				thumbnail = (product.artist.images ?
					(product.artist.images[0] || { }) : { }).url;
			}

			if (props.ticket_admin === true)
			{
				thumbnail = undefined;
			}
			else if (thumbnail)
			{
				thumbnail =
				(
					<Image src={ thumbnail } className="c-order-product__thumbnail-img"
						alt={ 'Image ' + product.name } />
				);
			}
			else
			{
				thumbnail =
				(
					<Logo src={ thumbnail } className="c-order-product__thumbnail-img"
						type="svg" synergies={ true } />
				);
			}

			let price = numeral(safeNumeral(product.price.price || 0));

			let total_price = numeral(price.value()).multiply(product.cart_qty);

			let selection;

			let id = order_id + '--' + product.id + '--' + product.price.ref;

			if (props.admin === true)
			{
				selection =
				(
					<div className="c-form-element c-form-element--checkbox">
						<input className="c-form__checkbox" name={ id }
							onChange={ function (e)
								{ component.selectItem(e, 'product', product); } }
							id={ id } type="checkbox"
							checked={ state.selected_products[id] || false } />
						<label className="c-form__checkbox-indicator"
							htmlFor={ id }></label>
					</div>
				);
			}

			let grouped = true;

			if ([true, 'true'].includes(product.is_individuel))
			{
				grouped = false;
			}

			if ([true, 'true'].includes(product.price.nominative))
			{
				grouped = false;
			}

			let date, age, position, ticket_type, validity_start, validity_date;
			let date_required_value;

			if (product.price.date)
			{
				date =
				(
					<span>
						&nbsp;| &nbsp;&nbsp;
						{ moment(product.price.date).format('ddd DD MMM YYYY - HH[h]mm') }
					</span>
				);
			}

			if (product.price.ticket_type && product.price.ticket_type.label)
			{
				ticket_type =
				(
					<span>
						&nbsp;| &nbsp;&nbsp;
						{ product.price.ticket_type.label }
					</span>
				);
			}

			if (product.price.position && product.price.position.label)
			{
				position =
				(
					<span>
						&nbsp;| &nbsp;&nbsp;
						{ product.price.position.label }
					</span>
				);
			}

			if (product.price.age && product.price.age.label)
			{
				age =
				(
					<span>
						&nbsp;| &nbsp;&nbsp;
						{ product.price.age.label }
					</span>
				);
			}

			if (product.date_required_value)
			{
				date_required_value =
				(
					<span>
						&nbsp;| &nbsp;&nbsp;1er Jour&nbsp;:&nbsp;
						{ moment(product.date_required_value).format('DD/MM/YYYY') }
					</span>
				);
			}

			if (product.price.validity_start)
			{
				validity_start =
				(
					<span>
						&nbsp;| &nbsp;&nbsp;
						Validité&nbsp;: { moment(product.price.validity_start).format('DD-MM-YYYY') }
					</span>
				);
			}

			if (product.price.validity_date)
			{
				if (product.price.validity_start)
				{
					validity_date =
					(
						<span>
							&nbsp;au { moment(product.price.validity_date).format('DD-MM-YYYY') }
						</span>
					);
				}
				else
				{
					validity_date =
					(
						<span>
							&nbsp;| &nbsp;&nbsp;
							Fin de validité&nbsp;: { moment(product.price.validity_date).format('DD-MM-YYYY') }
						</span>
					);
				}
			}

		/**
		 * Get product status (if product is grouped, any ticket is the status)
		 **/
			let product_status = Object.keys(product.tickets)
			.find(ticket_id => product.tickets[ticket_id]);

			if (product_status)
			{
				product_status = product.tickets[product_status].status;
			}

			if (product_status === 'canceled')
			{
				selection =
				(
					<Fragment>

						<div className="u-inline-block u-positioned">
							<div className="c-red-cross" />
						</div>

					</Fragment>
				);
			}

			let provider, provider_order, provider_transaction, cancel_product;

			if (props.admin)
			{
				let edit_icon =
				(
					<svg className="o-svg-icon o-svg-icon--edit c-order-infos__add-icon"
						key={ 0 }>
						<use xlinkHref="/images/icons.svg#svg-icon-edit"></use>
					</svg>
				);

				let class_name = 'c-order-infos__add-btn';

				provider_order =
				(
					<div className="c-order-product__provider-order">

						<span className="c-order-infos__long-text">
							{ product.provider_order }
						</span>

						<button className={ class_name + (product.provider_order ?
							' edit' : '') }
							onClick={ function (e)
							{
								app.emit('open__ProviderOrderModal',
								{
									product: product,
									order: props.data,
									number: product.provider_order
								});
							}}>
							{
								product.provider_order ? edit_icon : undefined
							}
						</button>
					</div>
				);

				if (product_status === 'canceled')
				{
					cancel_product =
					(
						<div className="c-order-product__cancel-product">
							{ !props.admin ? 'Oui' : undefined }
							<div className="u-inline-block u-positioned">
								<div className="c-red-cross" />
							</div>
						</div>
					);
				}
				else
				{
					cancel_product =
					(
						<div className="c-order-product__cancel-product">

							<button className="c-btn c-btn--cancel"
								onClick={ function (e)
								{
									app.emit('open__CancelProductModal',
									{
										tickets: product.tickets,
										product: product,
										order: props.data,
										ref: product.price.ref
									});
								}}>
							</button>
						</div>
					);
				}
			}

			if (props.ticket_admin === true)
			{
				provider =
				(
					<div className="c-order-product__provider">
						<span className="c-order-infos__long-text">
							{ product.provider ? product.provider.name : undefined }
						</span>
					</div>
				);

				let edit_icon =
				(
					<svg className="o-svg-icon o-svg-icon--edit c-order-infos__add-icon"
						key={ 0 }>
						<use xlinkHref="/images/icons.svg#svg-icon-edit"></use>
					</svg>
				);

				let class_name = 'c-order-infos__add-btn';

				provider_transaction =
				(
					<div className="c-order-product__provider-order">

						<span className="c-order-infos__long-text">
							{ product.provider_transaction }
						</span>

						<button className={ class_name + (product.provider_transaction ?
							' edit' : '') }
							onClick={ function (e)
							{
								app.emit('open__ProviderTransactionModal',
								{
									product: product,
									order: props.data,
									number: product.provider_transaction
								});
							}}>
							{
								product.provider_transaction ? edit_icon : undefined
							}
						</button>
					</div>
				);
			}

			let EC_order_as;

			if (product.EC_order_as && props.data.user.permissions.title === 'EC')
			{
				EC_order_as =
				(
					<div className="c-order-product__order-as">
						{ product.EC_order_as }
					</div>
				);
			}

			if (grouped === false)
			{
				let shipping_id;

				let exploded_products = Object.keys(product.tickets)
				.map(function (ticket_id)
				{
					let shipping = (props.shippings || [])
					.reduce(function (infos, shipping)
					{
						shipping.items.find(function (data)
						{
							if (data.id === ticket_id)
							{
								infos =
								{
									tracking: shipping.tracking,
									number: data.number
								};

								if (data.attachments && data.attachments.length)
								{
									infos.attachments = _.cloneDeep(data.attachments);
								}

								shipping_id = shipping.id;

								return true;
							}
						});

						return infos;
					},
					undefined);

					const ticket = product.tickets[ticket_id];

					if (props.admin === true)
					{
						selection = ticket.status !== 'canceled' &&
							props.data.status !== 'canceled'?
						(
							<div className="c-form-element c-form-element--checkbox">
								<input className="c-form__checkbox"
									name={ order_id + '--' + ticket_id }
									onChange={ function (e)
										{ component.selectItem(e, 'ticket', ticket_id); } }
									id={ order_id + '--' + ticket_id } type="checkbox"
									checked={ state.selected_tickets[ticket_id] || false } />
								<label className="c-form__checkbox-indicator"
									htmlFor={ order_id + '--' + ticket_id }></label>
							</div>
						)
						: undefined;
					}

					cancel_product = ticket.status === 'canceled' ?
					(
						<div className="c-order-product__cancel-product">
							{ !props.admin ? 'Oui' : undefined }
							<div className="u-inline-block u-positioned">
								<div className="c-red-cross" />
							</div>
						</div>
					)
					: ticket.status !== 'canceled' && props.admin ?
					(
						<div className="c-order-product__cancel-product">

							<button className="c-btn c-btn--cancel"
								onClick={ function (e)
								{
									app.emit('open__CancelProductModal',
									{
										tickets: product.tickets,
										ticket: ticket,
										ticket_id: ticket_id,
										product: product,
										order: props.data,
										ref: product.price.ref
									});
								}}>
							</button>
						</div>
					)
					: undefined;

					let shipping_ticket;

					if (ticket.status === 'canceled' ||
						props.data.status === 'canceled')
					{
						selection =
						(
							<div className="u-positioned">
								<div className="c-red-cross" />
							</div>
						);
					}
					else if (shipping)
					{
						selection =
						(
							<svg className="o-svg-icon o-svg-icon--shipping">
								<use xlinkHref="/images/icons.svg#svg-icon-shipping"></use>
							</svg>
						);

						if (props.admin === true)
						{
							selection =
							(
								<div className="u-positioned">

									{ selection }

									<button className="u-link-only"
									onClick={ function (e)
									{
										app.emit('open__ShippingDeliveryModal',
										{
											order_id: order_id,
											shipping_id: shipping_id
										});
									} }></button>

								</div>
							);
						}

						shipping_ticket = shipping.number;
					}

					let attachments;

					if (shipping && shipping.attachments && shipping.attachments[0])
					{
						attachments =
						(
							<a href={ shipping.attachments[0].url } target="_blank"
								className="c-btn c-btn--smaller" type="application/pdf" rel="noreferrer">
								Télécharger
							</a>
						);
					}

					let tracking;

					if (shipping && shipping.tracking)
					{
						tracking =
						(
							<a className="c-btn c-btn--smaller" target="_blank"
								rel="noreferrer" href=
								{
									'https://www.laposte.fr/particulier/outils/suivre-vos-envois' +
									'?code=' + shipping.tracking
								}>
								Suivre le colis
							</a>
						);
					}

					let names;

					if ([true ,'true'].includes(product.price.nominative) &&
						ticket.name)
					{
						names =
						(
							<span className="u-margin-left-10 u-margin-right-10">
								&nbsp;| &nbsp;&nbsp;
								{ ticket.name.firstname }
								{ ' ' }
								{ ticket.name.name }

								{
									ticket.name.date ?
										(
											' (' + moment(ticket.name.date)
											.format('DD-MM-YYYY') + ')'
										)
										: undefined
								}
							</span>
						);
					}

					if (props.admin)
					{
						let edit_icon =
						(
							<svg className="o-svg-icon o-svg-icon--edit c-order-infos__add-icon"
								key={ 0 }>
								<use xlinkHref="/images/icons.svg#svg-icon-edit"></use>
							</svg>
						);

						let class_name = 'c-order-infos__add-btn';

						provider_order =
						(
							<div className="c-order-product__provider-order">

								<span className="c-order-infos__long-text">
									{ ticket.provider_order }
								</span>

								<button className={ class_name +
									(ticket.provider_order ? ' edit' : '') }
									onClick={ function (e)
									{
										app.emit('open__ProviderOrderModal',
										{
											ticket: ticket,
											ticket_id: ticket_id,
											product: product,
											order: props.data
										});
									}}>
									{
										ticket.provider_order ?
											edit_icon : undefined
									}
								</button>
							</div>
						);
					}

				/**
				 * Special admin page with only show products and additionnal actions :
				 * • Products providers are shown
				 * • A provider order ref can be entered
				 * • A provider transaction can be entered
				 **/
					if (props.ticket_admin)
					{
						let edit_icon =
						(
							<svg className="o-svg-icon o-svg-icon--edit c-order-infos__add-icon"
								key={ 0 }>
								<use xlinkHref="/images/icons.svg#svg-icon-edit"></use>
							</svg>
						);

						let class_name = 'c-order-infos__add-btn';

						provider_transaction =
						(
							<div className="c-order-product__provider-order">

								<span className="c-order-infos__long-text">
									{ ticket.provider_transaction }
								</span>

								<button className={ class_name +
									(ticket.provider_transaction ? ' edit' : '') }
									onClick={ function (e)
									{
										app.emit('open__ProviderTransactionModal',
										{
											ticket: ticket,
											ticket_id: ticket_id,
											product: product,
											order: props.data,
											number: ticket.provider_transaction
										});
									}}>
									{
										ticket.provider_transaction ?
											edit_icon : undefined
									}
								</button>
							</div>
						);
					}

					if (props.admin !== true && ticket.status === 'canceled')
					{
						attachments = undefined;
					}

					let online_shipping;

					if (product.hasOwnProperty('cart_online_ticket'))
					{
						online_shipping = ['true', true]
						.includes(product.cart_online_ticket) ?
						(
							<span>
								&nbsp;| &nbsp;&nbsp;
								Livraison électronique
							</span>
						)
						: undefined;
					}
					else if ([true, 'true'].includes(product.price.online_ticket))
					{
						online_shipping =
						(
							<span>
								&nbsp;| &nbsp;&nbsp;
								Livraison électronique
							</span>
						);
					}

					let output =
					(
						<div className="c-order-product" key={ ticket_id }>

							<div className="c-order-product__selection">
								{ selection }
							</div>

							{
								props.ticket_admin === true ? undefined :
								(
									<div className="c-order-product__thumbnail">
										{ thumbnail }
									</div>
								)
							}

							<div className="c-order-product__title">
								{ product.name }
								{ date }
								{ names }
								{ ticket_type }
								{ position }
								{ age }
								{ validity_start }
								{ validity_date }
								{ date_required_value }
								{ online_shipping }
								{ tracking }
							</div>

							{ EC_order_as }

							<div className="c-order-product__ticket-number">
								{
									shipping_ticket ?
									(
										<span className="c-order-product__ticket-number-text">
											{ shipping_ticket }
										</span>
									)
									: undefined
								}

								{
									shipping_ticket ?
									(
										<button type="button"
											className="c-order-product__copy"
											onClick={ e => component
												.copyShippingNumber(shipping_ticket) }
											title="Copier le numéro">

											<FaRegCopy
												className="c-order-product__copy-icon"
											/>

										</button>
									)
									: undefined
								}

							</div>

							<div className="c-order-product__attachments">
								{ attachments }
							</div>

							{ provider }

							{ provider_order }

							{ provider_transaction }

							<div className="c-order-product__price">
								{ price.format('0[.]00') + '€' }
							</div>

							<div className="c-order-product__qty">x1</div>

							<div className="c-order-product__total-price">
								{ price.format('0[.]00') + '€' }
							</div>

							{ cancel_product }

						</div>
					);

					return output;
				});

				let output =
				(
					<Fragment key={ product.price.ref }>

						{ exploded_products }

					</Fragment>
				);

				return output;
			}

			let shipping_id;

			let shipping = (props.shippings || [])
			.reduce(function (infos, shipping)
			{
				shipping.products.find(function (data)
				{
					if (data.order_id === order_id && data.price_ref === product.price.ref)
					{
						infos =
						{
							tracking: shipping.tracking,
							number: data.number
						};

						if (data.attachments && data.attachments.length)
						{
							infos.attachments = _.cloneDeep(data.attachments);
						}

						shipping_id = shipping.id;

						return true;
					}
				});

				return infos;
			},
			undefined);

			let shipping_ticket;

			if (shipping)
			{
				selection =
				(
					<svg className="o-svg-icon o-svg-icon--shipping">
						<use xlinkHref="/images/icons.svg#svg-icon-shipping"></use>
					</svg>
				);

				if (props.admin === true)
				{
					selection =
					(
						<div className="u-positioned">

							{ selection }

							<button className="u-link-only"
							onClick={ function (e)
							{
								app.emit('open__ShippingDeliveryModal',
								{
									order_id: order_id,
									shipping_id: shipping_id
								});
							} }></button>

						</div>
					);
				}

				shipping_ticket = shipping.number;
			}

			let tracking;

			if (shipping && shipping.tracking)
			{
				tracking =
				(
					<a className="c-btn c-btn--smaller" target="_blank"
						rel="noreferrer" href=
						{
							'https://www.laposte.fr/particulier/outils/suivre-vos-envois' +
							'?code=' + shipping.tracking
						}>
						Suivre le colis
					</a>
				);
			}

			let attachments;

			if (shipping && shipping.attachments && shipping.attachments[0])
			{
				attachments =
				(
					<a href={ shipping.attachments[0].url } target="_blank"
						className="c-btn c-btn--smaller" type="application/pdf"
						rel="noreferrer">
						Télécharger
					</a>
				);
			}

			if (product_status === 'canceled' && props.admin !== true)
			{
				attachments = undefined;
			}

			let online_shipping;

			if (product.hasOwnProperty('cart_online_ticket'))
			{
				online_shipping = ['true', true]
				.includes(product.cart_online_ticket) ?
				(
					<span>
						&nbsp;| &nbsp;&nbsp;
						Livraison électronique
					</span>
				)
				: undefined;
			}
			else if ([true, 'true'].includes(product.price.online_ticket))
			{
				online_shipping =
				(
					<span>
						&nbsp;| &nbsp;&nbsp;
						Livraison électronique
					</span>
				);
			}

			let output =
			(
				<div className="c-order-product" key={ product.price.ref }>

					<div className="c-order-product__selection">
						{ selection }
					</div>

					{
						props.ticket_admin === true ? undefined :
						(
							<div className="c-order-product__thumbnail">
								{ thumbnail }
							</div>
						)
					}

					<div className="c-order-product__title">
						{ product.name }
						{ date }
						{ ticket_type }
						{ position }
						{ age }
						{ validity_start }
						{ validity_date }
						{ date_required_value }
						{ online_shipping }
						{ tracking }
					</div>

					{ EC_order_as }

					<div className="c-order-product__ticket-number">
						{ shipping_ticket }
					</div>

					<div className="c-order-product__attachments">
						{ attachments }
					</div>

					{ provider }

					{ provider_order }

					{ provider_transaction }

					<div className="c-order-product__price">
						{ price.format('0[.]00') + '€' }
					</div>

					<div className="c-order-product__qty">x{ product.cart_qty }</div>

					<div className="c-order-product__total-price">
						{ total_price.format('0[.]00') + '€' }
					</div>

					{ cancel_product }

				</div>
			);

			return output;
		});

		let product_abondement = numeral(
			safeNumeral(props.data.catalog_abondement || 0)
		);

		let user_abondement = numeral(
			safeNumeral(props.data.user_abondement || 0)
		);

		let all_selection;

		if (props.admin === true && props.data.status !== 'canceled')
		{
			all_selection =
			(
				<div className="c-form-element c-form-element--checkbox">
					<input className="c-form__checkbox" name={ 'order--' + order_id }
						onChange={ component.selectAllItems }
						id={ 'order--' + order_id } type="checkbox"
						checked={ state.all_selected || false } />
					<label className="c-form__checkbox-indicator"
						htmlFor={ 'order--' + order_id }></label>
				</div>
			);
		}

		let provider_header, provider_order_header, provider_transaction_header;
		let EC_order_as_header;

		if (props.admin)
		{
			provider_order_header =
			(
				<div className="c-order-product__provider-order">
					N° Fournisseur
				</div>
			);
		}
		else if (props.data.user.permissions.title === 'EC')
		{
			EC_order_as_header =
			(
				<div className="c-order-product__order-as">
					Au nom de
				</div>
			);
		}

		if (props.ticket_admin === true)
		{
			provider_header =
			(
				<div className="c-order-product__provider">
					Fournisseur
				</div>
			);

			provider_transaction_header =
			(
				<div className="c-order-product__provider-order">
					N° transaction
				</div>
			);
		}

		let header =
		(
			<div className="c-order-product c-order-product--header">

				<div className="c-order-product__selection">
					{ all_selection }
				</div>

				{
					props.ticket_admin === true ? undefined :
					(
						<div className="c-order-product__thumbnail">Image</div>
					)
				}

				<div className="c-order-product__title">Nom</div>

				{ EC_order_as_header }

				<div className="c-order-product__ticket-number">N° de billet</div>

				<div className="c-order-product__attachments">PDF</div>

				{ provider_header }

				{ provider_order_header }

				{ provider_transaction_header }

				<div className="c-order-product__price">Montant</div>

				<div className="c-order-product__qty">Qté</div>

				<div className="c-order-product__total-price">Prix total</div>

				{
					props.admin ?
					(
						<div className="c-order-product__cancel-product" />
					)
					: undefined
				}

			</div>
		);

		let status_label = 'En attente';
		let status_class = ' c-status-indicator--';

		if (props.data.status === 'new')
		{
			status_class += 'grey';
		}
		else if (props.data.status === 'processing')
		{
			status_class += 'blue';
			status_label = 'En traitement'
		}
		else if (props.data.status === 'completed')
		{
			status_class += 'green';
			status_label = 'Terminée';
		}
		else if (props.data.status === 'canceled')
		{
			status_class += 'red';
			status_label = 'Annulée';
		}

		let status =
		(
			<div className={ 'c-status-indicator' + status_class }>
				<div className="c-status-indicator__circle"></div>
				{ status_label }
			</div>
		);

		let payment_label = 'En attente';
		let payment_class = ' c-status-indicator--';

		if ([true, 'true'].includes(props.data.paid))
		{
			payment_class += 'green';
			payment_label = 'Validé';
		}
		else
		{
			payment_class += 'orange';

			if ([true, 'true'].includes(props.data.payment_refused))
			{
				payment_label = 'Échec';
			}
		}

		let payment_infos =
		(
			<div className={ 'c-status-indicator' + payment_class }>
				<div className="c-status-indicator__circle"></div>
				{ payment_label }
			</div>
		);

		let text = '', products_count = 0, total_price = numeral(0);

		props.data.products.forEach(function (product)
		{
			let price = numeral(safeNumeral(product.price.price));

			price.multiply(product.cart_qty);

			total_price.add(price.value());

			products_count += Number(product.cart_qty);
		});

		if (product_abondement.value() > 0)
		{
			total_price.subtract(product_abondement.value());
		}

		if (user_abondement.value() > 0)
		{
			total_price.subtract(user_abondement.value());
		}

		text = products_count + ' produits';

		if (app.state.session?.permissions?.title === 'EC' &&
			props.data?.admin_user?.id)
		{
			text +=
			[
				' | Commande passée par : ',
					props.data.admin_user.firstname || '',
					' ',
					props.data.admin_user.lastname || ''
			]
			.join('');
		}

		const user_comment = props.data.comment && props.data.comment !== ''
			? ' | commentaire : ' + props.data.comment
			: undefined;

		if (user_comment)
		{
			text += user_comment;
		}

		if (props.admin === true)
		{
			let payment_method =
			[
				{
					title: 'Paiement par CB',
					value: 'CC'
				},
				{
					title: 'Paiement par chèque',
					value: 'check'
				},
				{
					title: 'Paiement par virement',
					value: 'bank_transfert'
				},
				{
					title: 'Offert',
					value: 'free',
					info: 'Offert'
				}
			]
			.find(data => data.value === props.data.payment.method);

			if (typeof payment_method === 'undefined')
			{
				payment_method =
				{
					title: '',
					value: props.data.payment.method,
					price: '0'
				};
			}

			if (props.data.user.permissions.title === 'EC')
			{
				text =
				(
					<span>
						{ props.data.EC.company + ' - ' }

						<strong>
							{ props.data.EC.contact ?
								(' - ' + props.data.EC.contact + ' - ') : '' }
						</strong>

						{ payment_method.title }
						{
							props.data?.admin_user?.id ?
							(
								' | Élu : ' +
									props.data.admin_user.firstname + ' ' +
									props.data.admin_user.lastname
							)
							: undefined
						}
						{ user_comment }
					</span>
				);
			}
			else
			{
				text =
				(
					<span>
						{ props.data.billing.firstname + ' ' + props.data.billing.lastname }
						{ ' - ' }
						<strong>{ props.data.billing.email }</strong>
						{ ' - ' }
						{ payment_method.title }
						{ user_comment }
					</span>
				);
			}
		}

		let payment_actions, status_actions;

		if (props.admin === true && props.actions)
		{
			payment_actions = props.actions['payment'];
			status_actions  = props.actions['status'];
		}

		let download_bill = (isTrue(props.admin) || isTrue(props['EC-admin'])) &&
			isTrue(props.data?.billed) ?
		(
			<a className="c-btn c-btn--icon c-btn--ghost" target="_blank"
				rel="noreferrer" type="application/pdf"
				href={ '/PDF/facture/' + props.data?.bill_id }>
				<svg className="o-svg-icon o-svg-icon--PDF c-btn__icon">
					<use xlinkHref="/images/icons.svg#svg-icon-PDF"></use>
				</svg>
				{
					isTrue(props.admin)
					? 'Facture'
					: props.data?._bill?.text_number || 'Facture'
				}
			</a>
		)
		: undefined;

		let shipping_method =
		[
			{
				title: 'à domicile',
				value: 'home',
				price: '0'
			},
			{
				title: 'en CE',
				value: 'EC',
				price: '0'
			},
			{
				title: 'retrait Synergies',
				value: 'synergies',
				price: '0'
			},
			{
				title: 'électronique',
				value: 'online',
				price: '0'
			}
		]
		.find(data => data.value === props.data.shipping.method);

		if (typeof shipping_method === 'undefined')
		{
			shipping_method =
			{
				title: '',
				value: props.data.shipping.method,
				price: '0'
			};
		}

		let shipping_price = props.data.EC
			.config['shipping_' + props.data.shipping.method + '_price'];

		shipping_price = numeral(safeNumeral(shipping_price));

		let shipping =
		(
			<div className="c-order-product c-order-product--line">
				<div className="c-order-product__title">
					{ 'Livraison ' + shipping_method.title }
					{
						props.data.shipping?.client_phone ?
						(
							' - Tel. : ' + props.data.shipping.client_phone
						)
						: undefined
					}
				</div>

				<div className="c-order-product__price" />

				<div className="c-order-product__qty" />

				<div className="c-order-product__total-price">
					{ shipping_price.format('0[.]00') + '€' }
				</div>

				<div className="c-order-product__cancel-product" />
			</div>
		);

		const current_comment = state.hasOwnProperty('admin_comment')
		? state.admin_comment
		: props.data.admin_comment;

		let admin_comment = props.admin ?
		(
			<div className="c-order-product c-order-product--line">

				<div className="c-order-product__title">

					<span className="u-margin-right-15">Note interne</span>

					{
						current_comment ?
						(
							<span className="u-margin-right-15">
								{ current_comment }
							</span>
						)
						: undefined
					}

					<button type="button"
						className={ bemit('c-btn', ['smaller']) }
						onClick={ component.openCommentModal }>
						Modifier
					</button>

				</div>

			</div>
		)
		: undefined;

		total_price.add(shipping_price.value());

		let processed_by;

		if (props.admin === true)
		{
			let title = '';

			title += props.data.processed_by || '';

			if (props.data.processed_at)
			{
				title += moment(props.data.processed_at).format(' DD MMMM HH[h]mm');
			}

			processed_by =
			(
				<div className="c-order-infos__processed_by">
					<FormElement name={ props.data.id + '-processed_by' }
						type="checkbox" data={ state.form_data }
						onChange={ component.handleProcessedByChange }
						status={ state.status_messages } title={ title } />
				</div>
			);
		}

		let loader;

		if (state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />;
		}

		let order =
		(
			<div className="c-order-infos__order" onClick={ component.toggle }>

				<div className="c-order-infos__number"># { props.data.number }</div>

				{
					props['EC-admin'] === true ?
					(
						<div className="c-order-infos__bill">
							{ download_bill }
						</div>
					)
					: undefined
				}

				<div className="c-order-infos__total-price">
					{ total_price.format('0[.]00') + '€' }
				</div>

				<div className="c-order-infos__text">
					{ text }
				</div>

				{ processed_by }

				<div className="c-order-infos__payment u-no-select"
					onClick={ function (e)
					{
						if (props.onClick instanceof Function)
						{
							props.onClick(e, 'payment', props.data);
						}
					}}>
					{ payment_infos }

					{ payment_actions }
				</div>

				<div className="c-order-infos__status u-no-select"
					onClick={ function (e)
					{
						if (props.onClick instanceof Function)
						{
							props.onClick(e, 'status', props.data);
						}
					}}>

					{ status }

					{ status_actions }

				</div>

				{
					props.admin === true ?
					(
						<div className="c-order-infos__bill">
							{ download_bill }
						</div>
					)
					: undefined
				}

				{
					props.admin !== true ?
					(
						<div className="c-order-infos__collapse-indicator">
							<button type="button" className="c-order-infos__see-more">
								{ state.open ? '- Détail' : '+ Détail' }
							</button>
						</div>
					)
					: undefined
				}

				{ loader }

			</div>
		);

		if (product_abondement.value() > 0)
		{
			product_abondement =
			(
				<div className="c-order-product c-order-product--line">
					<div className="c-order-product__title">Abondement catalogue</div>

					<div className="c-order-product__price"></div>

					<div className="c-order-product__qty"></div>

					<div className="c-order-product__total-price">
						{ '-' + product_abondement.format('0[.]00') + '€' }
					</div>

					<div className="c-order-product__cancel-product" />
				</div>
			);
		}
		else
		{
			product_abondement = undefined;
		}

		if (user_abondement.value() > 0)
		{
			user_abondement =
			(
				<div className="c-order-product c-order-product--line">
					<div className="c-order-product__title">Abondement utilisateur</div>

					<div className="c-order-product__price"></div>

					<div className="c-order-product__qty"></div>

					<div className="c-order-product__total-price">
						{ '-' + user_abondement.format('0[.]00') + '€' }
					</div>

					<div className="c-order-product__cancel-product" />
				</div>
			);
		}
		else
		{
			user_abondement = undefined;
		}

		let detail =
		(
			<div className="c-order-infos__products">
				{ header }

				{ products }

				{ user_abondement }

				{ product_abondement }

				{ shipping }

				{ admin_comment }

				{
					component.state.open && props.admin && props.data?.bill_id ?
					(
						<OrderCreditNotes bill={ props.data.bill_id } />
					)
					: undefined
				}
			</div>
		);

		if (!component.state.open)
		{
			detail = undefined;
		}

		let date;

		if (props.show_date === true)
		{
			date = window.moment(props.data.createdAt)
			.format('ddd D MMMM YYYY');

			date =
			(
				<div className="c-order-infos__date u-no-select"
					onClick={ component.toggle }>
					{ date }
				</div>
			);
		}

		let output =
		(
			<div className={ 'c-order-infos' + (state.open ? ' c-order-infos--open' : '') }>

				{ date }

				{ order }

				{
					props['state-error']
					? getFormStatus({ error: props['state-error'] }, { style: { marginTop: 0 } })
					: undefined
				}

				{ detail }

			</div>
		);

		return output;
	}
}

export default OrderInfos